import Select from "components/Select";
import { Tooltip } from "components/Tooltip";
import {
  OUTPUT_FORMATS,
  getOutputFormatDisplayText,
  getFormatKeyFromText,
  getFormatOptions,
} from "pages/crawler/utils/outputFormatUtils";

interface OutputFormatSelectProps {
  outputFormat: string;
  autoparse: boolean | undefined;
  onChange: (outputFormat: string | undefined, autoparse: boolean | undefined) => void;
}

export const OutputFormatSelect = ({ outputFormat, autoparse, onChange }: OutputFormatSelectProps) => {
  return (
    <div>
      <label className="flex items-center text-sm font-medium text-gray-700 mb-1">
        <Tooltip content="Format for the scraped data. JSON/CSV use autoparse for structured data extraction. Markdown/Text are LLM-ready formats. Select 'Do not parse' for raw HTML.">
          Output format
        </Tooltip>
      </label>
      <Select
        name="outputFormat"
        value={getOutputFormatDisplayText(outputFormat, autoparse)}
        options={getFormatOptions()}
        className=""
        optionsClassName="max-h-52"
        onChange={(displayText: string) => {
          const key = getFormatKeyFromText(displayText);
          const config = OUTPUT_FORMATS[key];
          onChange(config.value, config.autoparse);
        }}
      />
    </div>
  );
};
